import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const TOO_LONG = 'tooLong';

export function maxLengthWithoutSpacesValidator(max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    const trimmedLength = value.replace(/\s/g, '').length;
    return trimmedLength > max
      ? { [TOO_LONG]: { requiredLength: max, actualLength: trimmedLength } }
      : null;
  };
}
